/*Popup*/

function popoverDestroyAll(){
    $(".fpopover").remove();
    return null;
}

function popoverGetContentBlock(obj, g_lang, lang){
    var split = obj.nodes[0].id.split("V_")[1];
    var _sectiontest = split.split("_test")[0];
    var _section = _sectiontest.split("_");
    var section = "";

    for(var i = 0; i < _section.length; i++) {
        section += _section[i] + " ";
    }

    var content = "<ul class='list-unstyled ticket-selected'>"+
                    "<li>"+
                        "<span class='ticket-lab'>Section </span> "+
                        "<span class='ticket-val'>"+section+"</span>"+
                    "</li>"+
                "</ul>";
    return content;
}

function popoverGetContentAreaImg(obj, g_lang, lang){
    var split = obj.nodes[0].id.split("V_")[1];
    var _sectiontest = split.split("_test")[0];
    var _section = _sectiontest.split("_");
    var section = "";

    for(var i = 0; i < _section.length; i++) {
        section += _section[i] + " ";
    }

    var content = "<div class='ticket-selected-view'>" +
                    "<div class='ticket-selected-view-img'></div>"+
                "</div>" +
                "<ul class='list-unstyled ticket-selected'>"+
                    "<li>"+
                        "<span class='ticket-lab'>Area </span> "+
                        "<span class='ticket-val'>"+section+"</span>"+
                    "</li>"+
                "</ul>";
    return content;
    
}

function popoverGetContentBlockImg(obj, g_lang, lang){
    var split = obj.nodes[0].id.split("V_")[1];
    if(split){
        var _sectiontest = split.split("_test")[0];
        var _section = _sectiontest.split("_");
        var section = "";
    
        for(var i = 0; i < _section.length; i++) {
            section += _section[i] + " ";
        }
    
        var content = "<div class='ticket-selected-view'>" +
                        "<div class='ticket-selected-view-img'></div>"+
                    "</div>" +
                    "<ul class='list-unstyled ticket-selected'>"+
                        "<li>"+
                            "<span class='ticket-lab'>Section </span> "+
                            "<span class='ticket-val'>"+section+"</span>"+
                        "</li>"+
                    "</ul>";
        return content;
    }
}

function popoverGetContentBlockVIP(obj, g_lang, lang){
    var split = obj.nodes[0].id.split("-");
    var section = split[0].split("_")[1];

    var content = "<div class='vip'><div class='ticket-selected-title gold'>" +
                    "<i class='fa fa-star'></i> VIP"+
                "</div>"+
                "<ul class='list-unstyled ticket-selected'>"+
                    "<li style='border-left: none;'>"+
                        "<span class='ticket-lab'>Section </span> "+
                        "<span class='ticket-val'>"+section+"</span>"+
                    "</li>"+
                "</ul></div>";
    return content;
}

function popoverGetContentBlockVIPImg(obj, g_lang, lang){
    var split = obj.nodes[0].id.split("-");
    var section = split[0].split("_")[1];

    var content = "<div class='vip'><div class='ticket-selected-title gold'>" +
                    "<i class='fa fa-star'></i> VIP"+
                "</div>"+
                "<div class='ticket-selected-view'>" +
                    "<div class='ticket-selected-view-img'></div>"+
                "</div>" +
                "<ul class='list-unstyled ticket-selected'>"+
                    "<li style='border-left: none;'>"+
                        "<span class='ticket-lab'>Section </span> "+
                        "<span class='ticket-val'>"+section+"</span>"+
                    "</li>"+
                "</ul></div>";
    return content;
}

function popoverGetContentSeatVIP(obj, g_lang, lang){
    var split = obj.nodes[0].id.split("-");
    var section = split[0].split("_")[1];
    var row = split[1];
    var seat = split[2];
    var content = "<div class='vip'><div class='ticket-selected-title gold'>" +
                    "<i class='fa fa-star'></i> VIP"+
                "</div><div class='ticket-selected-view'>" +
                    "<div class='ticket-selected-view-img'></div>"+
                "</div>" +
                "<ul class='list-unstyled ticket-selected'>"+
                    "<li style='border-left: none;'>"+
                        "<span class='ticket-lab'>Section </span>"+
                        "<span class='ticket-val'>"+section+"</span><span class='fa-slash'> / </span>"+
                    "</li>"+
                    "<li>"+
                        "<span class='ticket-lab'>Row </span>"+
                        "<span class='ticket-val'>"+row+"</span><span class='fa-slash'> / </span> "+
                    "</li>"+
                    "<li>"+
                        "<span class='ticket-lab'>Seat </span> "+
                        "<span class='ticket-val'>"+seat+"</span>"+
                    "</li>"+
                "</ul></div>";
    return content;
}

function popoverGetContentSeat(obj, g_lang, lang){
    var split = obj.nodes[0].id.split("-");
    var section = split[0].split("_")[1];
    var row = split[1];
    var seat = split[2];
    var content = "<div class='ticket-selected-view'>" +
                    "<div class='ticket-selected-view-img'></div>"+
                "</div>" +
                "<ul class='list-unstyled ticket-selected'>"+
                    "<li style='border-left: none;'>"+
                        "<span class='ticket-lab'>Section </span>"+
                        "<span class='ticket-val'>"+section+"</span><span class='fa-slash'> / </span>"+
                    "</li>"+
                    "<li>"+
                        "<span class='ticket-lab'>Row </span>"+
                        "<span class='ticket-val'>"+row+"</span> <span class='fa-slash'> / </span> "+
                    "</li>"+
                    "<li>"+
                        "<span class='ticket-lab'>Seat </span> "+
                        "<span class='ticket-val'>"+seat+"</span>"+
                    "</li>"+
                "</ul>";
    return content;
}

function popoverMove(popover,obj){
    obj = obj.nodes[0];
    if(popover){
        var w = popover.width();
        var h = popover.height();
        var p = popover[0];
        var bb = p.getBoundingClientRect();
        h = bb.height;
        var offset = viewer.scaling_factor-5;

        var top;
        if(obj.anchor.dom[1] < h){
            top= obj.anchor.dom[1]+17;
        }else{
            top= obj.anchor.dom[1]-(h)-15;
        }

        
        var left;
        if(obj.anchor.dom[0] < bb.width){
            left= obj.anchor.dom[0]+17;
        }else{
            left= obj.anchor.dom[0]-(w);
        }

        popover.css("top",top);
        popover.css("left",left);
    }
    return null;
}

function popoverOpen(obj, g_lang, lang){
    popoverDestroyAll();
    if(!interf.current){
        return;
    }

    /*Popover OBJ COnf*/
    var template;
    if(obj.nodes[0].type === "section" && interf.current == 'topview') {
        template = popoverGetContentAreaImg(obj, g_lang, lang);
    } else if(obj.nodes[0].type === "section" && interf.current == 'seatmap'){
        template = popoverGetContentBlockImg(obj, g_lang, lang);
    } else if(obj.nodes[0].type === "seat" && interf.current == 'seatmap'){
        if(list.length > 0) { } else { }
        template = popoverGetContentSeat(obj, g_lang, lang);
    }

    if(template){
        var popover = $("<div class='fpopover row'>"+template+"</div>");
        $("#main-interface").append(popover);

        popoverMove(popover,obj);

        viewer.getThumbnail(obj.nodes[0].id, venue_id).then(function(img){
            $(".ticket-selected-view-img").html("");
            $(".ticket-selected-view-img").css("background-image", "url("+img.src+")");
        })
        .catch(function(e){
            console.log(e);
        })
        
    }

    return true;
}